var map = {
	"./rev1.png": 3814,
	"./rev2.png": 9735,
	"./rev3.png": 212,
	"./rev4.png": 206,
	"./rev5.png": 4240,
	"./rev6.png": 1776,
	"./rev7.png": 948,
	"./rev8.png": 827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1919;